import React, { createContext, useState, useEffect } from 'react';

export const WaAuthContext = createContext();

export const WaAuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Read logged-in user from HRM sessionStorage
    const hrmUser = sessionStorage.getItem('user');
    if (hrmUser) {
      try {
        const parsed = JSON.parse(hrmUser);
        setCurrentUser({
          id: parsed.EmployeeId,
          email: parsed.Email || `${parsed.EmployeeId}@meridahr.com`,
          name: parsed.UserName || parsed.Name || 'HRM User',
          role: parsed.Disgnation || parsed.Designation || 'EMPLOYEE',
          whatsapp_access: parsed.user_permissions?.whatsapp_access || false,
        });
      } catch (e) {
        console.error('Error parsing HRM user for WA auth context', e);
      }
    }
  }, []);

  return (
    <WaAuthContext.Provider value={{
      currentUser,
      isAuthenticated: !!currentUser,
      loading,
    }}>
      {children}
    </WaAuthContext.Provider>
  );
};

